import { useSelector } from 'react-redux';
import { selectPreferredCurrency } from '../../slices/user/selectors';

const useCurrency = () => {
  const currency = useSelector(selectPreferredCurrency);

  const format = (amount, overrideCurrency) => {
    if (amount == null) return '—';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: overrideCurrency || currency,
    }).format(amount);
  };

  return { format, currency };
};

export default useCurrency;
